import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 从 sessionStorage 恢复登录态（刷新页面不丢失）
function loadUser() {
  try {
    const u = JSON.parse(sessionStorage.getItem('pollen_user') || 'null')
    if (u) return u
  } catch (e) { /* ignore */ }
  return null
}

// 读取主题偏好（localStorage 跨会话保留；默认亮色）
function loadTheme() {
  const t = localStorage.getItem('pollen_theme')
  return t === 'dark' || t === 'light' ? t : 'light'
}

export default new Vuex.Store({
  state: {
    // 当前登录用户信息（null 表示未登录）
    user: loadUser(),
    // 全局数据范围筛选
    scope: '全部区域',
    // 主题：light（正常）/ dark（暗色）
    theme: loadTheme()
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
    },
    SET_SCOPE(state, scope) {
      state.scope = scope
    },
    SET_THEME(state, theme) {
      state.theme = theme
    },
    CLEAR_USER(state) {
      state.user = null
    }
  },
  actions: {
    // 退出登录：清理本地状态并跳转登录页
    logout({ commit }) {
      sessionStorage.removeItem('pollen_token')
      sessionStorage.removeItem('pollen_user')
      commit('CLEAR_USER')
    }
  },
  modules: {}
})
